module.exports = __webpack_public_path__ + "img/NW16.cdc2b2dd.gif";